import { StorageService } from '../../storage';
import { STORAGE_KEYS } from '../../../constants';

const headers = {
  "X-PF-Allowed-Proxy": "1",
  "Content-Type": "application/x-www-form-urlencoded",
  Accept: "application/json"
}

// Garde double : ignoré sur tout build prod (CRA force NODE_ENV=production sur yarn build).
const BYPASS_AUTH =
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_BYPASS_AUTH === '1';

// Fonction pour gérer les erreurs 401
function handle401Error() {
  if (BYPASS_AUTH) {
    console.warn('[DEV] 401 ignored (bypass auth enabled)');
    return;
  }
  console.log('🚨 401 Unauthorized detected - Clearing auth token and redirecting to login');

  // Supprimer le token du localStorage
  StorageService.remove(STORAGE_KEYS.auth_token);
  StorageService.remove(STORAGE_KEYS.user);
  StorageService.remove(STORAGE_KEYS.loggin);

  // Supprimer les cookies
  document.cookie = 'jwt_pfid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  if (document.domain !== 'localhost') {
    document.cookie = `jwt_pfid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.${document.domain}; path=/;`;
  }

  // Recharger la page pour forcer une nouvelle authentification
  window.location.href = '/';
}


const RETRY_AFTER_FALLBACK_MS = 15000;

const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

// L'API limite le nombre de requetes par minute et par token. Un refus arrive en
// HTML : sans ce traitement, res.json() echoue et la page reste vide sans raison
// visible. On attend puis on retente une fois, en respectant Retry-After.
function retryDelayMs(res: Response) {
  const header = res.headers.get('retry-after');
  const seconds = header ? parseInt(header, 10) : NaN;
  if (!isNaN(seconds) && seconds > 0) return Math.min(seconds, 30) * 1000;
  return RETRY_AFTER_FALLBACK_MS + Math.floor(Math.random() * 5000);
}

async function ApiClientGet(url: string, token?: string, isRetry = false): Promise<any> {
  const options = token ? { ...headers, "X-Auth-Token": token } : headers;

  return fetch(url, { headers: options })
    .then(async res => {
      // Vérifier si c'est une erreur 401
      if (res.status === 401) {
        handle401Error();
        throw new Error('401 Unauthorized - Redirecting to login');
      }

      // Quota de requetes depasse : on attend et on retente une seule fois.
      if (res.status === 429) {
        if (isRetry) {
          throw new Error('429 Too Many Requests - quota API atteint');
        }
        const delay = retryDelayMs(res);
        console.warn(`429 reçu, nouvel essai dans ${delay}ms : ${url}`);
        await sleep(delay);
        return ApiClientGet(url, token, true);
      }

      if (!res.ok) {
        throw new Error(`HTTP ${res.status} sur ${url}`);
      }

      return res.json();
    })
    .then(res => res)
    .catch(err => {
      console.error('API GET Error:', err);
      throw err;
    });
}

async function ApiClientPost(url: string, payload?: any, token?: string) {
  const options = token ? { ...headers, "X-Auth-Token": token } : headers;
  return fetch(url, {
    method: 'POST',
    headers: options,
    body: payload
  }).then(res => {
    // Vérifier si c'est une erreur 401
    if (res.status === 401) {
      handle401Error();
      throw new Error('401 Unauthorized - Redirecting to login');
    }
    return res.json();
  })
    .then(res => res)
    .catch(err => {
      console.error('API POST Error:', err);
      throw err;
    });
}

const ApiClient = {
  get: ApiClientGet,
  post: ApiClientPost
}

export default ApiClient;